/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-tab-body-content{min-height:200px}agm-map{height:300px}.my-google-map .map-container{width:760px;height:600px}div.mat-checkbox-background{background-color:var(--background-tertiary)!important;color:var(--foreground-tertiary)!important}"];
export { styles as styles };
